const requested = new Map<string, Promise<void>>()

/** Starts (once) a background download for an image and resolves when it is decoded or fails. */
export function preloadImage(src: string): Promise<void> {
  if (typeof window === 'undefined') return Promise.resolve()
  const existing = requested.get(src)
  if (existing) return existing
  const promise = new Promise<void>((resolve) => {
    const img = new Image()
    img.decoding = 'async'
    img.onload = () => {
      if (img.decode) img.decode().then(() => resolve(), () => resolve())
      else resolve()
    }
    img.onerror = () => resolve()
    img.src = src
  })
  requested.set(src, promise)
  return promise
}

export function preloadImages(srcs: string[]): void {
  srcs.forEach((src) => void preloadImage(src))
}
